import React, { useState } from 'react';
import { Modal } from 'antd';
import { useAppSelector } from 'shared/store';
import { getProtocolVersion } from 'sb-lib/env';
import { ModalProps } from 'antd/lib/modal';
import {
  getStoredLastProtocolWarningTime,
  setStoredLastProtocolWarningTime,
} from 'shared/store/storage';
import './style.less';

export const ProtocolWarningModal: React.FC<ModalProps> = props => {
  const [hasShown, setHasShown] = useState(false);
  const { serverProtocolVersion, isConnectedToPeer } = useAppSelector(
    state => state.realtime,
  );
  const { account } = useAppSelector(state => state.auth);

  const isBehind =
    serverProtocolVersion !== null && serverProtocolVersion > getProtocolVersion();
  const wasShownRecently =
    Date.now() - getStoredLastProtocolWarningTime() < 1000 * 60 * 10;

  const handleOk = () => {
    setStoredLastProtocolWarningTime(Date.now());
    location.reload();
  };

  const handleCancel = () => {
    setHasShown(true);
  };

  const handleAfterClose = () => {
    setStoredLastProtocolWarningTime(Date.now());
  };

  const canShow =
    !!account && !isConnectedToPeer && !hasShown && isBehind && !wasShownRecently;

  return (
    <Modal
      {...props}
      className="ProtocolWarningModal"
      okText="Reload now"
      cancelText="I'll do it later"
      onOk={handleOk}
      onCancel={handleCancel}
      afterClose={handleAfterClose}
      visible={canShow}
    >
      {isBehind && (
        <>There is a new version of the site, please reload to get up to speed</>
      )}
    </Modal>
  );
};
